import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';
import { RENOLOG_ADMIN_LOCAL_API_REQUESTS } from './constants';

export const patchAdminSensorOrder = async (orderId, orderData) => {
  const signedRequest = await createSignedPatchRequest({
    apiPath: `admin/renolog/sensor-orders/${orderId}`,
    body: orderData,
    isLocalApiRequest: RENOLOG_ADMIN_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data;
};
